export default __webpack_public_path__ + "static/lozenge-dropdown-do-2-dark-60b8d675c5dc0dfe67f75b065fa1b46d7dba7dd2a1baec88813f556f289428f2.png";